import { api } from '../../base';
import {
    ICreateEmailTemplatePayload,
    IFetchEmailTemplatesParams,
    IPreviewTemplatePayload,
    IUpdateEmailTemplatePayload,
} from '../../common';

const BASE_URL = 'organizations/email-templates/';

export const fetchEmailTemplatesApi = (params: IFetchEmailTemplatesParams) => {
    return api.get({
        url: BASE_URL,
        queryParams: params,
    });
};

export const createEmailTemplateApi = (
    payload: ICreateEmailTemplatePayload
) => {
    return api.post({
        url: BASE_URL,
        data: payload,
    });
};

export const updateEmailTemplateApi = ({
    id,
    ...fields
}: IUpdateEmailTemplatePayload) => {
    return api.patch({
        url: `${BASE_URL}${id}/`,
        data: fields,
    });
};

export const deleteEmailTemplateApi = (id: number) => {
    return api.delete({
        url: `${BASE_URL}${id}/`,
    });
};

export const publishEmailTemplateApi = (
    id: number,
    data?: Omit<IUpdateEmailTemplatePayload, 'id'>
) => {
    return api.post({
        url: `${BASE_URL}${id}/publish/`,
        data,
    });
};

export const fetchEmailTemplateLabelsApi = () => {
    return api.get({
        url: `${BASE_URL}published_label_list/`,
    });
};

export const previewEmailTemplateApi = ({
    jobApplicationId,
    emailTemplateId,
}: IPreviewTemplatePayload) => {
    return api.post({
        url: `job-applications/${jobApplicationId}/preview_template_message/`,
        data: { email_template_id: emailTemplateId },
    });
};
